import { render } from "./mode.vue?vue&type=template&id=16229414&scoped=true"
import script from "./mode.vue?vue&type=script&lang=js"
export * from "./mode.vue?vue&type=script&lang=js"

import "./mode.vue?vue&type=style&index=0&id=16229414&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16229414"]])

export default __exports__